module.exports = __webpack_public_path__ + "img/BlinkArt_Bow_Epic.88a2d63e.png";